import vidyaBharathiLogo from '../../../../images/logos/vidyabharathi.png';

const template118 = {
  logo: vidyaBharathiLogo,
  fallbackLetter: 'V',
  brandName: 'Vidya Bharathi',
  brandTag: 'Group of Educational Institutions',
  schools: [
    { name: 'Vidya Bharathi High School',    area: 'Hyderabad' },
    { name: 'Vidya Bharathi Primary School', area: 'Hyderabad' },
  ],
  stampSize: 320, // smaller centered watermark (px)
};

export default template118;
